<template>
    <div class="vue-admin">
        <div class="header-banner"><h1>People &mdash; Admin</h1></div>
        <div class="page-space">
            <div class="ui secondary segment">
                <error-display v-if="error" :error="error"></error-display>
                <div class="ui grid">
                    <div class="eight wide column">
                        <router-link to="/admin/people/create" class="ui small green button" >
                            <i class="add user icon"></i> Add Person
                        </router-link>
                    </div>
                    <div class="eight wide column">
                        <label for="filter">Filters</label>
                        <input id="filter" v-model="filter">
                    </div>
                </div>
                <table class="ui small table segment">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Photo</th>
                            <th>Name</th>
                            <th>Location</th>
                            <th>Title</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="model in models" :key="model.id"
                            v-if="[model.last_name,model.first_name,model.title].join(',').toLowerCase().includes(filter.toLowerCase())">
                            <td><router-link :to="'/admin/people/'+model.id+'/edit'" class="ui mini button">Edit</router-link></td>
                            <td><img alt="default" class="img-in-list" :src="model.photo ? model.photo.folder + 'thumb_'+model.photo.file : '/img/default.jpg?v=1'"></td>
                            <td>{{model.first_name}} {{model.last_name}}</td>
                            <td>{{model.location}}</td>
                            <td>{{model.title}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import ErrorDisplay from "../errorDisplay";

    export default {
        components: {ErrorDisplay},
        data: function(){
            return {
                models: [],
                filter: '',
                error: null
            };
        },
        mounted: function(){

            document.title = 'People — Admin | ' + document.title.split(' | ').pop();
            axios.get('/admin/api/people')
                .then(response=>{if(response.status === 200) this.models = response.data;})
                .catch(error=>{this.error = {message:error.response}});
        },
        methods: {}
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/people/index.vue